export const removeUndef = obj => {
  Object.keys(obj).forEach(key => {
    if (obj[key] === undefined) {
      delete obj[key];
    }
  });
  return obj;
};

export const formatNumber = number => {
  if (typeof number !== 'number' || isNaN(number)) {
    return null;
  }
  return `${number
    .toString()
    .split(/(?=(?:...)*$)/)
    .join('.')}`;
};
